import { render } from "./Diabetology.vue?vue&type=template&id=5187ffaa"
import script from "./Diabetology.vue?vue&type=script&lang=ts"
export * from "./Diabetology.vue?vue&type=script&lang=ts"
script.render = render

export default script